import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import {
  useFoodTypesSelector,
  useGenerateFoodTypesObj,
} from 'src/hooks/useForm';
import CardFoodType from './CardFoodType';
import { useTranslation } from 'react-i18next';

const DonationFoodTypesSelector = ({
  value,
  onChange,
  isPartialRescue,
  recipients = [],
  errors = {},
  disabledRecipients = [],
  includeFoodTypes = true,
  disabledFoodTypes = [],
  destinationAddresses = [],
  onAddressChange,
  deliveryOption,
}) => {
  const { t } = useTranslation('translation');
  const generateFoodTypesObj = useGenerateFoodTypesObj();
  const foodTypes = useFoodTypesSelector();
  const filteredFoodTypes = foodTypes.filter(
    (foodType) => !!value[foodType.id]
  );

  return (
    <Stack spacing={2}>
      {includeFoodTypes && (
        <Stack spacing={1}>
          <Typography variant="h6">{t('donations.food-types')}</Typography>

          <Stack direction="row" gap={1} flexWrap="wrap">
            {foodTypes.map((item) => {
              return (
                <Chip
                  onClick={() => {
                    if (value[item.id]) {
                      onChange(
                        generateFoodTypesObj({
                          foodTypeNames: Object.keys(value).filter(
                            (foodType) => foodType !== item.id
                          ),
                          isPartialRescue,
                          existingFoodTypes: value,
                        })
                      );
                    } else {
                      onChange(
                        generateFoodTypesObj({
                          foodTypeNames: [...Object.keys(value), item.id],
                          isPartialRescue,
                          existingFoodTypes: value,
                        })
                      );
                    }
                  }}
                  key={item.id}
                  square
                  disabled={
                    (Object.keys(value).length === 1 && !!value[item.id]) ||
                    disabledFoodTypes.includes(item.id)
                  }
                  style={{
                    textTransform: 'capitalize',
                  }}
                  icon={
                    <item.icon
                      sx={{
                        width: 20,
                        height: 20,
                        marginRight: '3px !important',
                      }}
                    />
                  }
                  label={item.title}
                  color={value[item.id] ? 'primary' : 'default'}
                  variant={value[item.id] ? 'contained' : 'outlined'}
                />
              );
            })}
          </Stack>
        </Stack>
      )}

      <Box>
        {isPartialRescue ? (
          <Stack spacing={2}>
            {filteredFoodTypes.map((item) => {
              return (
                <Grid key={item.id} item xs={12} md={6}>
                  <CardFoodType
                    onChange={onChange}
                    disabledRecipients={disabledRecipients}
                    errors={errors}
                    item={item}
                    value={value}
                    handleInputChange={(foodTypeId) => (newValue) => {
                      onChange({
                        ...value,
                        [foodTypeId]: newValue,
                      });
                    }}
                    isPartialRescue={isPartialRescue}
                    recipients={recipients}
                    destinationAddresses={destinationAddresses}
                    onAddressChange={onAddressChange}
                    deliveryOption={deliveryOption}
                  />
                </Grid>
              );
            })}
          </Stack>
        ) : (
          <Grid container spacing={2}>
            {filteredFoodTypes.map((item) => {
              return (
                <Grid key={item.id} item xs={12} md={6}>
                  <CardFoodType
                    onChange={onChange}
                    disabledRecipients={disabledRecipients}
                    errors={errors}
                    item={item}
                    value={value}
                    handleInputChange={(foodTypeId) => (newValue) => {
                      onChange({
                        ...value,
                        [foodTypeId]: newValue,
                      });
                    }}
                    isPartialRescue={isPartialRescue}
                    recipients={recipients}
                    destinationAddresses={destinationAddresses}
                    onAddressChange={onAddressChange}
                    deliveryOption={deliveryOption}
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
      </Box>
    </Stack>
  );
};

export default DonationFoodTypesSelector;
